import { UnderConstructionPage } from '@components/app/UnderConstructionPage'
import { createFileRoute } from '@tanstack/react-router'
import { requireRouteAudience } from '@services/router/routeAccess'

export const Route = createFileRoute('/_layout/staff')({
    notFoundComponent: UnderConstructionPage,
    beforeLoad: requireRouteAudience(['staff', 'student']),
    staticData: {
        crumb: {
            label: 'Staff',
        },
    }
})
